export enum WafSchemaType {
  Sensitivity = 'waf_sensitivity_level',
  BlockAction = 'waf_block_action',
  RuleStatus = 'waf_rule_status',
  TargetLanguage = 'waf_target_language',
  ApplicationType = 'waf_application_type',
  RuleGroupName = 'waf_rule_group_name',
}
